var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { UserPageAppContext } from "./UserPageAppContextProvider";
import { getAssignableTasksRequest } from "../api/user-page-api";
import { SET_ASSIGNABLE_TASKS, SET_ASSIGNABLE_TASKS_LOADING, } from "../constants";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { reducer } from "../reducers/user-assignable-tasks-reducer";
const initialState = {
    loading: true,
    assignableTasks: [],
};
const UserAssignableTasksContext = createContext({
    state: initialState,
    userAssignableTasksDispatch: () => { },
    loadAssignableTasks: () => { },
});
const UserAssignableTasksContextProvider = ({ children, }) => {
    const [state, userAssignableTasksDispatch] = useReducer(reducer, initialState);
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    useEffect(() => {
        loadAssignableTasks();
    }, [pageHash]);
    const loadAssignableTasks = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            userAssignableTasksDispatch({
                type: SET_ASSIGNABLE_TASKS_LOADING,
                payload: true,
            });
            const response = yield getAssignableTasksRequest(pageHash);
            userAssignableTasksDispatch({
                type: SET_ASSIGNABLE_TASKS,
                payload: response.data,
            });
        }
        catch (error) {
            handleError(error);
        }
        finally {
            userAssignableTasksDispatch({
                type: SET_ASSIGNABLE_TASKS_LOADING,
                payload: false,
            });
        }
    });
    return (_jsx(UserAssignableTasksContext.Provider, { value: { state, userAssignableTasksDispatch, loadAssignableTasks }, children: children }));
};
export { UserAssignableTasksContext, UserAssignableTasksContextProvider, };
